function isEmptyNull(arr) {
  return arr === null || typeof arr === 'undefined' || arr.length === 0;
}

function isNotEmptyNull(arr) {
  return !isEmptyNull(arr);
}

const mergeOnKey = (target = [], source = [], key) => {
  return target.map(t => {
    const sourceObj = source.find(s => s[key] === t[key]);
    if (sourceObj) {
      return { ...t, ...sourceObj };
    }
    return t;
  });
};

export { isEmptyNull, isNotEmptyNull, mergeOnKey };
